import {Column} from '../shared/models/column';
import {ColumnType} from '../shared/enums/column-type.enum';
import { Client } from '../clients/client';

export class ClientDocument {
  // allColumns for DataTable
  static allColumns: Column[] = [
    new Column({name: '#', prop: 'id', type: ColumnType.Number, standard: true}),
    new Column({name: 'Datei', prop: 'file', type: ColumnType.String, standard: true}),
    new Column({name: 'Dokumententyp', prop: 'doc_type', type: ColumnType.Number, standard: true}),
    new Column({name: 'Gelöscht am', prop: 'deleted_at', type: ColumnType.DateTime, standard: true}),
    new Column({name: 'Erstellt am', prop: 'created_at', type: ColumnType.DateTime, standard: true}),
    new Column({name: 'Aktualisiert am', prop: 'updated_at', type: ColumnType.DateTime}),
    // Associated Columns
    new Column({name: 'Kunde', prop: 'client', association: 'belongs_to', columns: Client.allColumns}),
  ];

  // Simple Columns
  id: number;
  client_id: number;
  file: string;
  doc_type: number;
  deleted_at: boolean;
  created_at: boolean;
  updated_at: boolean;
  // Associations
  client: Client;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

  humanize() {
    return this.file;
  }
}

export class ClientDocumentList {
  count: number;
  data: ClientDocument[];

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
